import React from 'react';
import { Link } from 'react-router-dom';

interface TekkriHeaderProps {
  showBreadcrumb?: boolean;
  breadcrumbText?: string;
  breadcrumbLink?: string;
  actions?: React.ReactNode;
}

/**
 * TekkriHeader Component
 * Dark-themed header for Tekkr prototype matching the screenshot design
 */
const TekkriHeader: React.FC<TekkriHeaderProps> = ({
  showBreadcrumb = false,
  breadcrumbText,
  breadcrumbLink,
  actions
}) => {
  return (
    <header className="tekkr-header">
      <div className="tekkr-header-left">
        {/* Tekkr Logo */}
        <Link to="/tekkr/program-view" className="tekkr-logo">
          <img 
            src="/tekkr/logo.svg" 
            alt="Tekkr" 
            className="tekkr-logo-img"
          />
          <span>Tekkr</span>
        </Link>

        {/* Breadcrumb / Parent Link */}
        {showBreadcrumb && breadcrumbText && breadcrumbLink && (
          <Link to={breadcrumbLink} className="tekkr-breadcrumb">
            back to Program manager: {breadcrumbText}
          </Link>
        )}
      </div>

      {/* Header Actions */}
      {actions && (
        <div className="tekkr-header-actions">
          {actions}
        </div>
      )}
    </header>
  );
};

export default TekkriHeader;

